
import { userSlice } from './slices/user';

import type { Action, ThunkAction } from "@reduxjs/toolkit"
import { asyncThunkCreator, buildCreateSlice, combineSlices, configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { useDispatch, useSelector } from 'react-redux';
import { storageSlice } from './slices/storage';
import { creationsSlice } from './slices/creations';
import { productsSlice } from './slices/products';
import { contentSlice } from './slices/content';
import { subscriptionsSlice } from './slices/subscriptions';
import {
  coursesSlice
} from './slices/learningCourses';
import { notificationsSlice } from './slices/notifications';

const rootReducer = combineSlices(
  storageSlice,
  userSlice,
  creationsSlice,
  productsSlice,
  contentSlice,
  coursesSlice,
  notificationsSlice,
  subscriptionsSlice,
)
export type RootState = ReturnType<typeof rootReducer>

export const makeStore = (preloadedState?: Partial<RootState>) => {
  const store = configureStore({
    reducer: rootReducer,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    // middleware: getDefaultMiddleware => {
    //   return getDefaultMiddleware().concat(quotesApiSlice.middleware)
    // },
    preloadedState,
  })
  setupListeners(store.dispatch)
  return store
}

export const store = makeStore();

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()


// Infer the type of `store`
export type AppStore = typeof store
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore["dispatch"]
export type AppThunk<ThunkReturnType = void> = ThunkAction<
  ThunkReturnType,
  RootState,
  unknown,
  Action
>
